import { __extends } from "tslib";
import * as React from 'react';
import { Popover } from '../../../primitives';
import { Label } from '../labels';
import { classNames } from '@wix/answers-lib';
import ResizeObserver from 'resize-observer-polyfill';
export var overflowLabelViewKey = 'overflow-label-view';
export var MAX_VISIBLE_LABELS = 5;
export var SHOW_MORE_OFFSET = 40;
var OverflowLabelView = /** @class */ (function (_super) {
    __extends(OverflowLabelView, _super);
    function OverflowLabelView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            popoverIsOpen: false,
            popoverIsHovered: false,
            visibleLabels: 0,
        };
        _this.observer = null;
        _this.elementRef = null;
        _this.popoverTimeout = null;
        _this.setElement = function (e) {
            if (!_this.elementRef && e) {
                _this.elementRef = e;
                setTimeout(function () {
                    _this.calculateVisibleLabels();
                }, 400);
            }
        };
        _this.hidePopover = function () {
            if (_this.popoverTimeout) {
                clearTimeout(_this.popoverTimeout);
            }
            _this.setState({ popoverIsOpen: false });
        };
        _this.onPopoverhover = function () {
            _this.setState({ popoverIsHovered: true });
        };
        _this.onStopPopoverhover = function () {
            _this.setState({ popoverIsHovered: false });
        };
        _this.calculateVisibleLabels = function () {
            var _a;
            _this.setState({ visibleLabels: _this.props.labels.length });
            if (_this.props.maxVisibleLabels === 1) {
                _this.setState({ visibleLabels: _this.props.maxVisibleLabels });
                return;
            }
            var currentWidth = ((_a = _this.elementRef) === null || _a === void 0 ? void 0 : _a.clientWidth) || 0;
            var labelsWidth = _this.elementRef ? Array.from(_this.elementRef.querySelectorAll('.visible-label-container'))
                .map(function (el) {
                return el.clientWidth;
            }) : [];
            var reducedArr = [];
            var LABEL_MARGIN = 4;
            labelsWidth.reduce(function (prev, curr) {
                reducedArr.push(prev - curr);
                return prev - curr - LABEL_MARGIN;
            }, currentWidth);
            var maxFittingLabels = reducedArr.filter(function (num) { return num >= SHOW_MORE_OFFSET; }).length;
            if (_this.props.maxVisibleLabels !== undefined && maxFittingLabels > _this.props.maxVisibleLabels) {
                maxFittingLabels = _this.props.maxVisibleLabels;
            }
            var visibleLabels = !maxFittingLabels && _this.props.showFirst ? 1 : maxFittingLabels;
            _this.setState({ visibleLabels: visibleLabels });
        };
        _this.openPopover = function () {
            _this.popoverTimeout = setTimeout(function () {
                _this.setState({ popoverIsOpen: true });
            }, _this.props.delayTime || 0);
        };
        return _this;
    }
    OverflowLabelView.prototype.componentDidMount = function () {
        this.calculateVisibleLabels();
        if (this.elementRef && ResizeObserver) {
            this.observer = new ResizeObserver(this.calculateVisibleLabels);
            this.observer.observe(this.elementRef);
        }
    };
    OverflowLabelView.prototype.componentDidUpdate = function () {
        this.calculateVisibleLabels();
    };
    OverflowLabelView.prototype.componentWillUnmount = function () {
        if (this.observer) {
            this.observer.disconnect();
        }
    };
    OverflowLabelView.prototype.render = function () {
        var _a = this, props = _a.props, state = _a.state;
        var visibleLabelsCount = state.visibleLabels;
        var visibleLabels = visibleLabelsCount ? props.labels.slice(0, visibleLabelsCount) : [];
        var hiddenLabels = visibleLabelsCount ? props.labels.slice(visibleLabelsCount) : props.labels;
        var showMoreLabelsClassNames = classNames('show-more-labels', { small: props.smallShowMorePopover });
        var moreLabelsBody = (React.createElement("div", { className: showMoreLabelsClassNames, onMouseOver: this.onPopoverhover, onMouseLeave: this.onStopPopoverhover }, hiddenLabels.map(function (label, idx) { return React.createElement("span", { className: 'hidden-label-container', key: idx }, label); })));
        var showMoreLabel = hiddenLabels.length > 0 ? (React.createElement(Popover, { isOpen: state.popoverIsOpen || state.popoverIsHovered, body: moreLabelsBody, onOuterAction: this.openPopover, preferPlace: 'above' },
            React.createElement("span", { className: 'show-more-label', onMouseOver: this.openPopover, onMouseOut: this.hidePopover },
                React.createElement(Label, { color: '#FFF', borderColor: '#D0EDFF', borderless: props.borderless, size: props.showMoreLabelsize, className: 'show-more-title' },
                    "+",
                    hiddenLabels.length)))) : null;
        return (React.createElement("div", { ref: this.setElement, className: classNames(overflowLabelViewKey, 'view-container') },
            React.createElement("div", { className: classNames('current-labels', { 'with-hidden': hiddenLabels.length > 0 }) }, visibleLabels.map(function (label, idx) { return React.createElement("span", { className: 'visible-label-container', key: idx }, label); })),
            showMoreLabel));
    };
    return OverflowLabelView;
}(React.PureComponent));
export { OverflowLabelView };
//# sourceMappingURL=index.js.map